<template>
  <div class="c_advantages">
    <div class="c_advantage__item">
      <div class="c_advantage__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="1.8rem" height="1.8rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M8 12h.01"/><path d="M12 12h.01"/><path d="M16 12h.01"/></svg>
        </div>
      <div class="c_advantage__text">
        <span style="font-weight: 600; font-size: 1.2rem; text-align: left;">Онлайн поддержка</span>
        <span style="text-align: left;">Ответим на ваши вопросы</span>
      </div>
    </div>

    <div class="c_advantage__item">
      <div class="c_advantage__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="1.8rem" height="1.8rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>
      </div>
      <div class="c_advantage__text">
        <span style="font-weight: 600; font-size: 1.2rem; text-align: left;">Быстрая доставка</span>
        <span style="text-align: left;">Доставим на следующий день!</span>
      </div>
    </div>

    <div class="c_advantage__item">
      <div class="c_advantage__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="1.8rem" height="1.8rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>
      </div>
      <div class="c_advantage__text">
        <span style="font-weight: 600; font-size: 1.2rem; text-align: left;">Акции и скидки</span>
        <span style="text-align: left;">Скидки на товары</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoAdvantages"
}
</script>

<style scoped lang="scss">
  .c_advantages{
    background-color: var(--separator-color-light);
    padding: 1rem;
    width: 100%;
    height: max-content;
    display: flex;
    gap: 1rem;
    justify-content: space-around;
    flex-direction: row;
    border-radius: .4rem;
  }

  .c_advantage__item{
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 1rem;
  }

  .c_advantage__text{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.6rem;
    justify-content: center;
  }

  .c_advantage__icon{
    background-color: var(--theme-color-7);
    border-radius: .2rem;
    width: 3rem;
    height: 3rem;
    color: var(--button-text-color);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  //MOBILE
  @media screen and (max-width: 768px) {
    .c_advantages{
      display: flex;
      flex-direction: column;
    }
  }
</style>